/**
 * Created by Workaxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Date: 23/10/23
 * Time: 3:22 pm
 * Project: W-CRM-Frontend
 */
import React, {useEffect, useImperativeHandle, useMemo, useRef, useState} from "react";
import "./style.css";
import ModernSelect from "../ModernSelect/ModernSelect";
import InfoLabel from "../InfoLabel/InfoLabel";
import {useDispatch, useSelector} from "react-redux";
import {
    getUsersSelectionListRequest,
    OrganizationState,
    usersSelectionListReset,
} from "../../redux/Organization/organizationReducer";

// Optional props (existing callers are unaffected):
// - baseQuery: extra query args sent with the initial load and every search, e.g. {status: "active"}
// - value: controlled selected user id; when set, it is shown instead of the internal selection
// - onUsersLoaded(results, {searched, hasMore}): called after each list response
// callback receives (id, user) where user is the selected user object when known.
export const UserSelection = React.forwardRef(({selectedUser, label = "user", callback, exclude = [], baseQuery = null, value, onUsersLoaded = null}, ref) => {
    const dispatch = useDispatch();
    const {usersSelectionList: users} = useSelector(OrganizationState);
    const lastSearchRef = useRef("");

    const getUsersList = useMemo(() => {
        const results = users?.data?.results || [];
        const selectedUserAlreadyExists = results.some((i) => i.id === selectedUser?.id);

        const mapped = results.filter(i => !exclude.includes(i.id)).map((i) => ({
            id: i.id,
            value: `${i.first_name} ${i.last_name}`,
        }));
        if (selectedUser && !selectedUserAlreadyExists) {
            mapped.push({
                id: selectedUser.id,
                value: `${selectedUser.first_name} ${selectedUser.last_name}`,
            });
        }
        return mapped;
    }, [selectedUser, users?.data]);

    const userSearch = (key) => {
        lastSearchRef.current = key || "";
        dispatch(getUsersSelectionListRequest({...(baseQuery || {}), q: key}));
    };
    useEffect(() => {
        dispatch(getUsersSelectionListRequest({...(baseQuery || {})}));
        return () => {
            dispatch(usersSelectionListReset());
        };
        // baseQuery only shapes the initial load; changing it later must not refetch and reset the list.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (!onUsersLoaded || users?.isLoading || !users?.data) return;
        onUsersLoaded(users.data.results || [], {
            searched: lastSearchRef.current.length > 0,
            hasMore: !!users.data.next,
        });
        // Report once per list response, not when the parent re-creates the callback.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users?.data, users?.isLoading]);

    const [selected, setSelected] = useState(null)
    const clearSelection = () => {
        setSelected(null)
    }

    useImperativeHandle(ref, () => ({
        clearSelection() {
            return clearSelection();
        },
    }));

    return (
        <InfoLabel label={label}>
            {/*<Spinner isSpinning={users.isLoading}>*/}
            <ModernSelect
                // preSelected={selectedUser ? selectedUser.id : null}
                preSelected={value !== undefined ? value : selected}
                isLoading={users.isLoading}
                isSearch={true}
                options={getUsersList}
                searchCallback={userSearch}
                onSelect={(val) => {
                    setSelected(val)
                    const user = (users?.data?.results || []).find((i) => i.id === val)
                        || (selectedUser?.id === val ? selectedUser : null);
                    callback(val, user)
                }}
                disabled={users.isLoading}
            />
            {/*</Spinner>*/}
        </InfoLabel>
    );

})